import { KalturaBrowserHttpClient } from 'kaltura-typescript-client';
import { SessionStartAction } from 'kaltura-typescript-client/types/SessionStartAction';
import { KalturaSessionType } from 'kaltura-typescript-client/types/KalturaSessionType';
import { MediaGetAction } from 'kaltura-typescript-client/types/MediaGetAction';

const config = {
  clientTag: 'descomplica',
  endpointUrl: 'https://www.kaltura.com',
};
const client = new KalturaBrowserHttpClient(config);

export const authenticate = async () => {
  const authenticationToken = await client.request(
    new SessionStartAction({
      secret: process.env.VUE_APP_KALTURA_SECRET,
      type: KalturaSessionType.user,
      partnerId: parseInt(process.env.VUE_APP_KALTURA_PARTNER_ID),
    }),
  );

  client.ks = authenticationToken;
};

export const getVideoInfo = async (entryId: string) => {
  return await client.request(new MediaGetAction({ entryId, version: -1 }));
};
